

























































































































































































































































































import { Component } from "vue-property-decorator";
import { GENDER } from "@/utils/store-util";
import Vue from "vue";
import { userModule } from "@/store/modules/user";
import http from "@/http/axios";
import { placeModule } from "@/store/modules/place";


@Component
export default class Login extends Vue {
  private email = "";
  private registeritem = {
    place:"",
  };
  private show_pass = false;
  private show_confim_pass = false;
  public notice = "";
  private pass = "";
  private confirm_pass = "";
  private id_card = "";
  private name = "";
  private title = "";
  private snackbar = false;
  private gender = "";
  private phone = "";
  private error = false;
  private signuperror = false;
  private s_text = "";
  private s_color = "";
  private text = "No Response";
  private loading = false;
  private valid = true;
  private timeout = 500000;
  private registerDialog = false;
  private forgetDialog = false;
  private verifyDialog = false;
  private dateMenu = false;
  private date = new Date().toISOString().substr(0, 10);
  public gotoDashboard() {
    this.$router.push("/");
  }

  private verify = {
    email: "",
    verify_code: "",
    new_pass: "",
    new_pass_verify: ""
  };

  public async register() {
    this.loading = true;
    await placeModule.placetoCode(this.registeritem);
    const params = {
      email: this.email,
      password: this.pass,
      confirm_password: this.confirm_pass,
      birthday: this.date,
      id_card: this.id_card,
      name: this.name,
      gender: this.gender,
      phone: this.phone,
      place: this.registeritem.place,
      title: this.title,
    };
    const result = await http.put("/auth", params);
    if (result) {
      if (result.data.status === "Success") {
        this.registerDialog = false;
      }else{
        if(typeof result.data.message === "string"){
          this.signuperror = true;
          this.text = result.data.message;
        }else{
          this.signuperror = true;
          this.text = result.data.message.en;
        }
      }
      this.loading = false;
    }
  }

  get place(){
    return placeModule.place;
  }

  async created() {
    await placeModule.placeList(true);
    if (userModule.isSignedIn) {
      userModule.logout();
    }
  }

  async destroyed() {
    await this.clearLogin();
  }

  async forgetPassword() {
    const params = {
      email: this.verify.email
    };
    const result = await http.post("/auth/password/reset", params);
    if (result) {
      if (result.data.status === "Success") {
        this.verifyDialog = true;
      } else {
        this.s_color = "error";
        this.s_text = "傳送驗證碼錯誤，請確認信箱是否輸入正確";
        this.snackbar = true;
      }
    } else {
      this.s_color = "error";
      this.s_text = "傳送驗證碼錯誤，請確認信箱是否輸入正確";
      this.snackbar = true;
    }
  }

  async newPassword() {
    if (this.verify.new_pass_verify !== this.verify.new_pass) {
      this.s_color = "error";
      this.s_text = "新密碼與確認新密碼不相同";
      this.snackbar = true;
      return;
    }
    const params = {
      email: this.verify.email,
      code: this.verify.verify_code,
      password: this.verify.new_pass,
      password_confirm: this.verify.new_pass_verify
    };
    const result = await http.put("/auth/password/reset", params);

    if (result) {
      if (result.data.status === "Success") {
        this.s_color = "success";
        this.s_text = "修改新密碼成功";
        this.snackbar = true;
        this.closePass();
      } else {
        this.s_color = "error";
        this.s_text = result.data.message;
        this.snackbar = true;
      }
    } else {
      this.s_color = "error";
      this.s_text = result.data.message;
      this.snackbar = true;
    }
  }

  closePass() {
    this.forgetDialog = false;
    this.verifyDialog = false;
    this.verify = {
      email: "",
      verify_code: "",
      new_pass: "",
      new_pass_verify: ""
    };
  }

  public async login() {
    this.loading = true;
    // this.$Progress.start();
    const params = {
      email: this.email,
      password: this.pass
    };
    const result = await http.post("/auth", params);
    if (result) {
      if (result.data.status === "Success") {
        // Login Successful
        
        const data = result.data.data;
        data.user.gender = GENDER[data.user.gender];
        const userData = {
          accessToken: data.session.token,
          user: data.user
        };

        userModule.signIn(userData);
        
        if(data.user.roles.includes('Owner')||data.user.roles.includes('Admin')){
          console.log('admin');
          this.$router.push({ name: "社區地圖統計" }).catch(err => {
            console.log('map error');
            console.log(err);
          });
        }else{
          console.log('user');
          this.$router.push({ name: "血壓脈搏圖表" }).catch(err => {
            console.log('dashboard error');
            console.log(err);
          });
        }
        
      } else {
        // Login Failed
        this.error = true;
        this.text = result.data.message;
        console.log(`Login Failed`);
      }
    } else {
      this.error = true;
      this.text = "No Response";
      console.log(`error`);
    }
    this.loading = false;
  }

  clearLogin() {
    this.closePass();
    this.email = "";
    this.pass = "";
    this.confirm_pass = "";
    this.id_card = "";
    this.name = "";
    this.gender = "";
    this.phone = "";
  }
}
